import React from 'react';

interface SettingsCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const SettingsCard: React.FC<SettingsCardProps> = ({ title, description, children }) => {
  return (
    <div className="bg-white dark:bg-luna-primary rounded-xl border border-luna-text-light/10 dark:border-luna-text-dark/20 shadow-sm p-6">
      <h2 className="text-xl font-bold mb-2">{title}</h2>
      <p className="text-luna-text-light/70 dark:text-luna-text-dark/70 mb-6">{description}</p>
      <div>
        {children}
      </div>
    </div>
  );
};